/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_DiscordInputs */



/**
* | output |
* | --- |
* | "Do I need the Discord bot to run an online event?" |
*
* @param {Og_Faq_Q_DiscordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_discord = /** @type {((inputs?: Og_Faq_Q_DiscordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_DiscordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ai-je besoin du bot Discord pour organiser un événement en ligne ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Necesito el bot de Discord para organizar un evento en línea?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Preciso do bot do Discord para realizar um evento online?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ho bisogno del bot Discord per gestire un evento online?")
	return /** @type {LocalizedString} */ ("Do I need the Discord bot to run an online event?")
});